<template>
    <div class="about-wrapper">
      <div class="header-about-background">
        <div
          data-aos="fade-up"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="header-title-container"
        >
          <h2 class="about-header-title">Vilkår for bruk</h2>
        </div>
      </div>
      <div class="content-wrapper">
        <h3>1. Firma</h3>
            <p>
                Disse vilkår og betingelser gjelder for bestilling på nett av {{ restaurant.restaurantName }}, organisasjonsnummer {{ restaurant.organizationNumber }}.<br>
                <br>
                Kontakt informasjon <br>
                Telefon nummer: (+47) {{ restaurant.phoneNumber }} <br>
                Epost adresse: post@fujisushi.no <br>
                Juridisk adresse: {{ restaurant.address }}, {{ restaurant.postNumber }}, {{ restaurant.city }} <br>
            </p>
            <p>
                <br>
                www.fujisushi.no er levert av Transoft Tan Hoang Duy Tran, organisasjonsnummer 920809480. Informasjon og bilder på nettstedet er eid av selskapet eller partner og kan ikke kopieres uten tillatelse. <br>
                <br>
                Kontakt informasjon <br>
                Telefon nummer: 40671226 <br>
                Epost adresse: post@transoft.com <br>
                Juridisk adresse: Blichs gate 4, 3044, Drammen
            </p>
          
            <h3>2. Priser</h3>
            <p>
                Alle priser vises i Norske kroner og er inkludert MVA. I handlekurven ser du totalprisen inkludert alle avgifter.
            </p>

            <h3>3. Betaling</h3>
            <p>
                Betaling skjer ved den valgte betalingsmetode i kassa. Betalingsløsningen er levert av Nets og det tilbys kortbetaling og Vipps. Trekk av kort gjøres umiddelbart etter at bestillingen er gjennomført. Andre henvendelser hva gjelder betaling bes ta kontakt med kundeservice på ks@fujisushi.no.
            </p>

            <h3>4. Personvern, sikkerhet og personopplysninger</h3>
            <p>
                I forbindelse med bestillingen, godtar du av vi lagrer og bruker informasjonen din. Vi gjør dette for å oppfylle våre forpliktelser overfor deg. Vi dokumenterer også all kommunikasjon vi har med deg via e-post, for å kunne tilby tjenesten som du forventer av oss. Vi vil ikke dele dine personlige informasjon til tredjepart.
            </p>
            <h3>5. Kontakt & Support</h3>
            <p>
                Kontakt og support vil du finne HER
            </p>
            <h3>6. Cookies</h3>
            <p>
                En cookie er en tekstfil som sendes fra et nettsted til datamaskinen der den er lagret enten i minnet (sessioncookies) eller som en tekstfil (tekstbaserte informasjonskapsler). Cookies brukes til å lagre logg-inn eller handlekurven mens du surfer rundt på ulike nettsteder. Hvis nettleseren din er satt til å ikke akseptere cookies, vil du ikke være i stand til å gjøre noen ordre på nettstedet vårt. Du kan enkelt endre dette i innstillingene til nettleseren din. Vær oppmerksom på at vi ikke bruker cookies for å lagre personlig informasjon om deg.
            </p>
            <h3>7. Force majeure</h3>
            <p>
                Særlige omstendigheter som ikke er under menneskelig kontroll slik som krig, omfattende arbeidskonflikt, blokade, brann, miljøkatastrofe, alvorlig infeksjon som hindrer partene å oppfylle sine forpliktelser kan frigjøre en part fra forpliktelsene. Slikt unntak gjelder under forutsetning av at operasjonen ikke kan utføres under disse betingelsene. Den andre parten skal straks varsles om omstendighetene ved bruk av denne bestemmelsen.
            </p>
            <h3>8. Endring av kontrakt</h3>
            <p>
                Etter at du som kunde har gjort et kjøp har vi har ikke rett til å endre vilkårene i det aktuelle kjøpet med mindre annet er avtalt
            </p>
            <h3>9. Klager</h3>
            <p>
                Ved klage, vennligst kontakt oss på post@fujisushi.no
            </p>
            <h3>9.1. Tvister og lover</h3>
            <p>
                Norsk lov skal gjelde for alle kjøp gjort under disse vilkårene. Tvister om kjøp under disse vilkår skal utelukkende behandles av en Norsk domstol.
            </p>
            <h3>10. Oppdatering av vilkår</h3>
            <p>
                Vi vil fra tid til annen oppdatere våre vilkår og betingelser etter eget skjønn. Om dette finner sted, vil vi gi klar beskjed i app og nettbutikk.
            </p>

        </div>
       
    </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex'
  export default {
    components: {},
    computed : {   
        ...mapGetters({
            restaurant : 'restaurants/currentRestaurant'
        })
    },
    data() {
      return {
        about: require("@/assets/images/calli-great.png"),
        team: require("@/assets/images/teamphoto.jpg"),
        dualBackground: require("@/assets/images/9.jpg"),
        dualForeground: require("@/assets/images/14.jpg"),
        resultSushi: require("@/assets/images/12.jpg")
      };
    }

  };
  </script>
  
  <style lang="scss" scoped>
  $desktop: 1200px;
  $laptop: 1024px;
  $tablet: 768px;
  $mobile: 480px;
  
  .dual-images-text-holder-second {
    padding: 7em 0 0 14em;
    font-size: calc(16px + 0.2vw);
    text-align: right;
  
    @media (width: 1280px) {
      padding: 4em 0 0 6em;
    }
    @media (max-width: 1024px) {
      padding: 0em 0 0 0em;
    }
    @media (max-width: $mobile) {
      text-align: center;
    }
    & p {
      font-family: Roboto, sans-serif;
      font-weight: 500;
    }
  }
  .dual-images-holder-second {
    display: flex;
    justify-content: flex-end;
    margin: 0 9rem;
  
    @media (width: 1280px) {
      margin: 0 6rem;
    }
    @media (max-width: 1024px) {
      margin: 0 2rem;
    }
  }
  
  .dual-title-second {
    font-size: 35px;
    font-family: bebas;
  }
  
  .dual-text-second {
    color: #878787;
    margin-top: 20px;
    line-height: 30px;
  }
  .dual-images-holder {
    margin: 0 9rem;
    @media (width: 1280px) {
      margin: 0 6rem;
    }
    @media (max-width: 1024px) {
      margin: 0 2rem;
    }
  
    & img {
      border-radius: 10%;
    }
  }
  
  .dual-images-text-holder {
    padding: 7em 14em 0 0;
    font-size: calc(16px + 0.2vw);
    color: #000000;
    @media (width: 1280px) {
      padding: 4em 6em 0 0;
    }
    @media (max-width: 1024px) {
      padding: 0em 0em 0 0;
    }
    @media (max-width: $mobile) {
      text-align: center;
    }
    & p {
      font-family: Roboto, sans-serif;
      font-weight: 500;
    }
  }
  .dual-title {
    font-size: 35px;
    font-family: bebas;
  }
  
  .dual-text {
    color: #878787;
    margin-top: 20px;
    line-height: 30px;
  }
  .dual-showcase-foreground-second {
    position: relative;
    border-radius: 10%;
  
    & img {
      border-radius: 10%;
    }
  }
  .dual-showcase-foreground {
    position: relative;
    left: 35%;
    bottom: 35%;
  }
  .dual-showcase-background {
    box-shadow: 2px 10px 21px -5px rgba(0, 0, 0, 0.75);
    height: auto;
    border-radius: 10%;
  }
  
  .content-dual-wrapper {
    margin-top: 20px;
  }
  .content-dual-title-section {
    margin-top: 10rem;
    @media (max-width: $mobile) {
      margin-top: 15rem;
    }
  }
  
  .content-process-section-second {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    @media (max-width: $mobile) {
      display: flex;
  
      flex-direction: column-reverse;
    }
  }
  .content-process-section {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  
    @media (max-width: $mobile) {
      display: flex;
      flex-direction: column;
    }
  }
  
  .content-intro-section {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-gap: 1rem;
  }
  
  .team-intro-text {
    font-family: Roboto, sans-serif;
    font-size: calc(16px + 0.2vw);
    line-height: 2em;
    text-align: center;
    margin-left: 5%;
    font-weight: 700;
  }
  .content-wrapper {
    margin: 0;
    font-family: Roboto, sans-serif;
    overflow: hidden;
  
    @media (max-width: $mobile) {
      margin: 0;
    }
  }
  
  .content-intro-wrapper {
    margin: 0 6.5vw 0 6.5vw;
    background-image: url("~@/assets/images/brush-stroke.png");
  
    background-size: 70%;
    background-repeat: no-repeat;
    height: 700px;
    background-position: -60px 110px;
  }
  .content-intro-title-section {
    margin-bottom: 80px;
  }
  .team-photo {
    height: auto;
    border-radius: 8%;
    max-height: 500px;
    box-shadow: 2px 10px 21px -5px rgba(0, 0, 0, 0.75);
    @media screen and (max-width: 2600px) and (min-width: 2000px) {
      margin-left: 100px;
    }
  }
  
  .content-intro-title {
    margin-bottom: 10rem;
    text-align: center;
    text-transform: uppercase;
    font-size: 58px !important;
    font-family: Bebas, sans-serif;
    font-weight: 400 !important;
  }
  .header-about-background {
    background-image: url("~@/assets/images/chef-team.jpg");
    background-size: cover;
    height: 490px;
    width: 100%;
    object-fit: cover;
    margin-top: 10px;
    display: grid;
    place-items: center;
  
    @media (max-width: $mobile) {
      height: 200px;
      position: static;
      bottom: 0;
    }
  }
  
  /* //.about-header-title {
    position: relative;
    bottom: 330px;
    text-transform: uppercase;
    font-family: Roboto, sans-serif;
    font-size: 50px;
  
    width: 100%;
    text-align: center;
  }
   */
  .header-title-container {
    background-color: white;
  
    height: 200px;
    width: 18%;
    border-radius: 50px;
    display: grid;
    place-items: center;
    @media (max-width: $mobile) {
      height: 105px;
      width: 50%;
      border-radius: 30px;
    }
  }
  h4 {
    text-align: center;
    font-family: Roboto, sans-serif;
    font-weight: 400 !important;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: #878787;
    position: relative;
    top: 25px;
    @media (max-width: $mobile) {
      font-size: 1em;
      top: 10px;
    }
  }
  .about-header-title {
    text-align: center;
    text-transform: uppercase;
    font-family: Bebas;
    font-weight: 400;
    margin: 0 0 0.67em 0;
    font-size: 2vw;
    margin: 0;
    @media (max-width: $mobile) {
      font-size: 2em;
      position: relative;
      bottom: 10px;
    }
  }
  .about-title-logo {
    position: relative;
    bottom: 20px;
    width: 80px;
    @media (max-width: $mobile) {
      height: 60px;
      width: auto;
    }
  }
  </style>
  